import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!

  return (_openBlock(), _createBlock(_component_a_descriptions, {
    column: 1,
    bordered: "",
    class: "infoDescription"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_descriptions_item, { label: "车架号：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data.vinNo), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_descriptions_item, { label: "车型：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data.model), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_descriptions_item, { label: "发票日期：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data.invoiceDate), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_descriptions_item, { label: "上牌日期：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data.licenseDate), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_descriptions_item, { label: "客户姓名：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data.customerName), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_descriptions_item, { label: "零售类型：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data.usage), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_descriptions_item, { label: "提交状态：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.EnumControllingApprovalStatus[_ctx.data.approlStatus]), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_descriptions_item, { label: "激励适用性：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.EnumControllingCheckStatus[_ctx.data.checkStatus]), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}